import { render, staticRenderFns } from "./ComplaintsListDialog.vue?vue&type=template&id=9fcf5e84&scoped=true&"
import script from "./ComplaintsListDialog.vue?vue&type=script&lang=js&"
export * from "./ComplaintsListDialog.vue?vue&type=script&lang=js&"
import style0 from "./ComplaintsListDialog.vue?vue&type=style&index=0&id=9fcf5e84&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fcf5e84",
  null
  
)

export default component.exports